import { useState, useEffect } from "react";

export default function AgeGate({ onConfirm }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem("kv_age_ok");
    if (!ok) setVisible(true);
  }, []);

  const confirm = () => {
    localStorage.setItem("kv_age_ok", "1");
    setVisible(false);
    onConfirm && onConfirm();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="age-gate-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/95 backdrop-blur-3xl"
    >
      <div className="border border-[#1C1C1F] bg-[#0A0A0A] p-8 sm:p-12 max-w-lg w-full text-center shadow-[0_0_60px_rgba(229,0,0,0.12)] fade-up">
        <div className="font-mono text-[10px] tracking-[0.3em] text-[#0066FF] mb-4">EXPLICIT CONTENT · 18+</div>
        <h1 className="font-heading text-4xl sm:text-6xl uppercase tracking-tighter text-white mb-4 leading-none break-words">
          Age Verification
        </h1>
        <p className="text-[#A1A1AA] text-sm mb-2">
          This site contains adult gay kink &amp; fetish material intended for mature audiences only.
        </p>
        <p className="text-[#52525B] text-xs mb-8">
          By entering you confirm you are at least 18 years old (or the legal age in your jurisdiction) and consent to viewing explicit content.
        </p>
        <div className="flex flex-col gap-3">
          <button
            data-testid="age-gate-enter-btn"
            onClick={confirm}
            className="bg-[#0066FF] text-white font-heading uppercase tracking-[0.2em] text-sm px-8 py-4 hover:bg-[#0055CC] transition-colors duration-300 border border-[#0066FF]"
          >
            I am 18 or older — Enter
          </button>
          <a
            href="https://www.google.com"
            data-testid="age-gate-exit-btn"
            className="text-[#52525B] hover:text-[#A1A1AA] transition-colors text-xs font-mono uppercase tracking-wider py-2"
          >
            Leave this site
          </a>
        </div>
      </div>
    </div>
  );
}
